// material-ui

// import { useLocation } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
//import useConfig from 'hooks/useConfig';
import AwsGraphs from './AwsGraphs';

// ================================|| AUTH3 - LOGIN ||================================ //

const PdfSuccess = () => {
    const location = useLocation();
    const { data, isLoading, error } = location.state || {};

    return <AwsGraphs data={data} loading={isLoading} error={error} />;
};

export default PdfSuccess;
